import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import frequentlyBoughtTogetherQuery from './query'
import {
  IFrequentlyBoughtTogetherResponse,
  IFrequentlyBoughtTogetherVariables,
} from './types'

/**
 * Hook declaration to obtain a lazy query of frequently bought together products
 * @param options: LazyQueryHookOptions without the fetch-policy keys
 * @internal
 */
const useLazyGetFrequentlyBoughtTogether = (
  options?: Omit<
    LazyQueryHookOptions<
      IFrequentlyBoughtTogetherResponse,
      IFrequentlyBoughtTogetherVariables
    >,
    'fetchPolicy' | 'nextFetchPolicy' | 'initialFetchPolicy'
  >,
) => {
  return useLazyQuery<
    IFrequentlyBoughtTogetherResponse,
    IFrequentlyBoughtTogetherVariables
  >(frequentlyBoughtTogetherQuery, {
    ...options,
    fetchPolicy: 'no-cache',
    // Neutralised beside the pin, not merely omitted from the type: both
    // survive the spread otherwise, and `nextFetchPolicy` would take over
    // from the second fetch onward.
    nextFetchPolicy: undefined,
    initialFetchPolicy: undefined,
  })
}

export { useLazyGetFrequentlyBoughtTogether }
